(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/game-card-error.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/game-card-error.js');

'use strict';

const _React = React,
  useContext = _React.useContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody,
  CardHeader = _svs$ui$ReactCard.CardHeader;
const Icon = svs.ui.ReactIcon;
const Brand = svs.ui.ReactBrand;
const productMapping = svs.numbergames.productMapping;
const ContainerContext = svs.numbergames.fractiongames.contexts.ContainerContext;
const GameCardError = () => {
  const _useContext = useContext(ContainerContext),
    selectors = _useContext.selectors;
  const containerId = useSelector(selectors.selectContainerId);
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const _useSelector = useSelector(selectors.selectGame),
    jokerPrice = _useSelector.jokerPrice;
  const branding = productMapping.getBrandingClass(productNumeric);
  return React.createElement("div", {
    className: "ng-fg-card ng-fg-card-error ng-fg-card-container-".concat(containerId)
  }, React.createElement(Card, {
    align: "center",
    branding: "tur",
    className: "branding-".concat(branding)
  }, React.createElement(CardHeader, null, React.createElement("div", {
    className: "ng-fg-card-header-brand"
  }, React.createElement("h2", null, React.createElement(Brand, {
    brand: branding,
    size: 100
  }), Boolean(jokerPrice) && React.createElement("p", null, "med Joker")))), React.createElement(CardBody, null, React.createElement(Icon, {
    size: "400",
    icon: "exclamation-sign"
  }), "Ett fel har uppst\xE5tt.")));
};
svs.numbergames.fractiongames.components.gamecard.GameCardError = GameCardError;

 })(window);